var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-PB"},[_c('iframe',{attrs:{"title":"Informe 70 años","width":"100%","height":"100%","src":"https://app.powerbi.com/view?r=eyJrIjoiYTM4Zjc4MWYtZTBmZi00OGNkLTgzM2UtMzFjNjgzZDI2MjI1IiwidCI6IjllMDQ0ZjE3LWM3M2MtNGU1ZC04NWViLTMyNDNlNTU1YjczOSIsImMiOjR9","frameborder":"0","allowFullScreen":"true"}})])
}]

export { render, staticRenderFns }